import { render, staticRenderFns } from "./ModalFormulario.vue?vue&type=template&id=d4608f6e&scoped=true"
import script from "./ModalFormulario.vue?vue&type=script&lang=js"
export * from "./ModalFormulario.vue?vue&type=script&lang=js"
import style0 from "./ModalFormulario.vue?vue&type=style&index=0&id=d4608f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4608f6e",
  null
  
)

export default component.exports